export class StringUtils {
    static capitalize = (targetString: string) =>
        targetString.charAt(0)
            .toUpperCase()
        + targetString.slice(1);

    static utf8_to_base64(str: string) {
        return window.btoa(unescape(encodeURIComponent(str)));
    }
}
